export default {"src":"/_next/static/media/level_of_protection_image.c1983f98.svg","height":159,"width":237,"blurWidth":0,"blurHeight":0};